import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const title = 'Flexbox Grid';
export const _frontmatter = {};
const layoutProps = {
  title,
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "flexbox-grid"
    }}>{`Flexbox Grid`}</h1>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live=true",
        "live": "true"
      }}>{`<Flex mx={-2}>
  <Box width={1/2} px={2}>
    <Text p={1} color='background' bg='primary'>
      Half
    </Text>
  </Box>
  <Box width={1/2} px={2}>
    <Text p={1} color='background' bg='primary'>
      Half
    </Text>
  </Box>
</Flex>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      